module.exports = __webpack_public_path__ + "static/media/marginalia-girl-computer.33f66d46.svg";